import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { BodyText, theme, useResponsive } from '@sg/garnish';

import { useTrademark } from '../../../hooks';
import { DebugMenuTrigger } from '../../DebugMenu';

export const OrganizationLinksFooterCopyright = () => {
  const { formatMessage } = useIntl();
  const trademark = useTrademark();

  const { minWidth } = useResponsive();
  const alignmentStyle = minWidth.isMD ? styles.alignmentMD : undefined;

  return (
    <View>
      <BodyText style={alignmentStyle}>
        {formatMessage(messages.footerCopyright, { year: CURRENT_YEAR })}
      </BodyText>

      {trademark ? (
        <BodyText style={[styles.trademark, alignmentStyle]}>{trademark}</BodyText>
      ) : null}

      <BodyText style={alignmentStyle}>
        <DebugMenuTrigger />
      </BodyText>
    </View>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  footerCopyright: {
    defaultMessage: '©sweetgreen {year}',
    description: 'Footer | Copyright',
  },
});

// ─── Constants ───────────────────────────────────────────────────────────────

const CURRENT_YEAR = new Date().getFullYear();

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  alignmentMD: {
    textAlign: 'right',
  },
  trademark: {
    marginBottom: theme.spacing['4'],
  },
});
